// Zelle „Aufnahme“ der Anrufliste (Aktivitäten > Anrufe, T47): der Player, wenn zu dem Anruf eine Aufnahme (Close-Altbestand) oder
// eine Mailbox-Nachricht abspielbar ist; „abgelaufen“, wenn Close sie schon gelöscht hat; sonst leer. Nur Anrufe aus Close
// (`acti_…`) mit Gesprächszeit oder Mailbox-Ergebnis fragen nach.
import { AufnahmePlayer } from "../components/AufnahmePlayer";
import { useAufnahmeHinweis } from "./aufnahmeHinweise";
import { ablaufText } from "./logik";
import "./gespraeche.css";

interface Props {
  id: string;
  dauerS: number | null | undefined;
  ergebnis: string | null | undefined;
}

export function fragtNachAufnahme(id: string, dauerS: number | null | undefined, ergebnis: string | null | undefined): boolean {
  return id.startsWith("acti_") && ((dauerS ?? 0) > 0 || ergebnis === "vm-left" || ergebnis === "vm-answer");
}

export function AufnahmeZelle({ id, dauerS, ergebnis }: Props) {
  const hinweis = useAufnahmeHinweis(id, fragtNachAufnahme(id, dauerS, ergebnis));
  if (!hinweis || !hinweis.art) return null;
  if (hinweis.verfuegbar) {
    // Der Klick gehört dem Player, nicht der Zeile (sonst öffnet er den Lead)
    return (
      <span className="gesp-zelle" title={ablaufText(hinweis.laeuft_ab_am)} onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
        <AufnahmePlayer callId={id} art={hinweis.art} dauerS={hinweis.dauer_s ?? dauerS ?? null} laeuftAbAm={hinweis.laeuft_ab_am} kompakt />
      </span>
    );
  }
  if (hinweis.grund === "abgelaufen") return <span className="leise" title="Close löscht Aufnahmen nach 7 Tagen.">abgelaufen</span>;
  return null;
}
